// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cebeb858","453":"6fc3b5c9","732":"c2ccf63e"}[chunkId] + ".chunk.js";
};